import { render, staticRenderFns } from "./templateCard.vue?vue&type=template&id=cddfe400&scoped=true&"
import script from "./templateCard.vue?vue&type=script&lang=js&"
export * from "./templateCard.vue?vue&type=script&lang=js&"
import style0 from "./templateCard.vue?vue&type=style&index=0&id=cddfe400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddfe400",
  null
  
)

export default component.exports